import { Suspense } from "react";
import { Outlet } from "react-router";
import { Loader } from "./components/loader";
import styles from "./root-layout.module.css";

export default function RootLayout() {
  return (
    <div className={styles.rootLayout}>
      {/* The Suspense boundary sits around the routed content only, so loading a
          lazy route swaps the page area rather than the whole document */}
      <Suspense fallback={<Loader />}>
        <Outlet />
      </Suspense>
    </div>
  );
}
